import * as React from "react"
const SvgMailRemove = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M4 20.714q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 18.714v-12q0-.086.006-.168L2 6.539h.007q.057-.714.58-1.237A1.93 1.93 0 0 1 4 4.714h16q.824 0 1.413.588.523.524.58 1.237H22l-.006.007q.006.083.006.168v7a1 1 0 1 1-2 0V8.59l-6.975 4.175A2 2 0 0 1 12 13.04q-.55 0-1.025-.275L4 8.59v10.125h7c.552 0 1 .524 1 1.076s-.448.924-1 .924H4Zm15.255-14H4.745L12 11.04z"
      clipRule="evenodd"
    />
    <path d="M14.287 19.427q.288.288.713.287h6q.424 0 .712-.287a.97.97 0 0 0 .288-.713.97.97 0 0 0-.288-.712.97.97 0 0 0-.712-.288h-6a.97.97 0 0 0-.713.288.97.97 0 0 0-.287.712.97.97 0 0 0 .287.713" />
  </svg>
)
export default SvgMailRemove
